import React from 'react';
import { useAuth } from '@repo/common';
import Applications from './Applications/Applications';
import Resumes from './Resumes/Resumes';
import EmployerJobs from './EmployerJobs/EmployerJobs';

// 어드민도 기업과 같은 지원자 관리 화면을 본다 (서버는 전체 공고를 내려준다)
const BUSINESS_ROLES = new Set([
  'E',
  'ROLE_E',
  'EMPLOYER',
  'ROLE_EMPLOYER',
  'EMPLOYEE',
  'ROLE_EMPLOYEE',
  'A',
  'ROLE_A',
  'ADMIN',
  'ROLE_ADMIN',
]);

const MyApply = () => {
  const { user } = useAuth();
  const isBusiness = BUSINESS_ROLES.has(
    String(user?.role ?? '').toUpperCase(),
  );

  if (isBusiness) {
    return <EmployerJobs isAdmin={['A', 'ROLE_A', 'ADMIN', 'ROLE_ADMIN'].includes(String(user?.role ?? '').toUpperCase())} />;
  }

  return (
    <div className='flex flex-col w-full items-center gap-[60px] tabletH:gap-0'>
      <Applications />
      <Resumes />
    </div>
  );
};

export default MyApply;
